/* @refresh reload */
import { render } from "solid-js/web";
import { Router, Route, Navigate } from "@solidjs/router";
import App from "./App";
import CalendarPage from "./pages/CalendarPage";
import WorkoutsPage from "./pages/WorkoutsPage";
import WorkoutEditorPage from "./pages/WorkoutEditorPage";
import WorkoutDetailPage from "./pages/WorkoutDetailPage";
import ActiveWorkoutPage from "./pages/ActiveWorkoutPage";
import TemplatesPage from "./pages/TemplatesPage";
import ExercisesPage from "./pages/ExercisesPage";
import StatsPage from "./pages/StatsPage";
import ProfilePage from "./pages/ProfilePage";
import WeightPage from "./pages/WeightPage";
import AdminPage from "./pages/AdminPage";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

render(
  () => (
    <Router root={App}>
      <Route path="/" component={CalendarPage} />
      <Route path="/workouts" component={WorkoutsPage} />
      <Route path="/workouts/active" component={ActiveWorkoutPage} />
      <Route
        path="/workouts/new/completed"
        component={() => <WorkoutEditorPage kind="completed" mode="create" />}
      />
      <Route
        path="/workouts/new/planned"
        component={() => <WorkoutEditorPage kind="planned" mode="create" />}
      />
      <Route
        path="/workouts/completed/:id"
        component={() => <WorkoutDetailPage kind="completed" />}
      />
      <Route
        path="/workouts/planned/:id"
        component={() => <WorkoutDetailPage kind="planned" />}
      />
      <Route
        path="/workouts/completed/:id/edit"
        component={() => <WorkoutEditorPage kind="completed" mode="edit" />}
      />
      <Route
        path="/workouts/planned/:id/edit"
        component={() => <WorkoutEditorPage kind="planned" mode="edit" />}
      />
      <Route path="/exercises" component={ExercisesPage} />
      <Route path="/templates" component={TemplatesPage} />
      <Route path="/stats" component={StatsPage} />
      <Route path="/weight" component={WeightPage} />
      <Route path="/admin" component={AdminPage} />
      <Route path="/profile" component={ProfilePage} />
      <Route path="*404" component={() => <Navigate href="/" />} />
    </Router>
  ),
  root,
);
